import styled from 'styled-components'

import { updatedMedia } from 'client/styles'
import { ButtonIcon } from 'src/comps/Button/styles'
import {
  CalendarBase as RangeCalendarBase,
  WeekDays,
  Month,
} from 'client/components/DatePicker/styles'

export const CalendarBase = styled.div`
  height: calc(100% - 154px);
  z-index: 1;
  ${updatedMedia.desktop} {
    padding-block: 30px 20px;
    padding-inline: 30px;
    position: absolute;
    inset-block-start: calc(100% + 10px);
    inset-inline-start: -210px;
    height: auto;
    border: 2px solid ${({ theme }) => theme.colors.grey2};
    border-radius: 8px;
    background-color: ${({ theme }) => theme.colors.grey8};
    z-index: 11;
  }
  ${WeekDays} {
    border-block-end: 1px solid ${({ theme }) => theme.colors.grey5};
    ${updatedMedia.desktop} {
      margin-block-end: 8px;
    }
  }
  ${RangeCalendarBase} {
    padding-block: 18px;
    padding-inline: 0;
    border-block-end: 1px solid ${({ theme }) => theme.colors.grey5};
    ${updatedMedia.desktop} {
      border: none;
      padding-block: 0;
      padding-inline: 0;
    }
  }
  ${Month} {
    padding-block: 0 8px;
    padding-inline: 8px;
  }
`

export const AddMonths = styled(ButtonIcon)`
  width: 100%;
  padding-block: 15px;
  padding-inline: 0;
  box-shadow: 0px -1px 2px 0px rgba(0, 0, 0, 0.15);
  ${updatedMedia.desktop} {
    display: none;
  }
`

export const CalendarWrapper = styled.div`
  border-block-end: 1px solid ${({ theme }) => theme.colors.grey5};
  padding-block-end: 25px;
  margin-block-end: 16px;
  overflow-y: auto;
  height: 100%;
  ${updatedMedia.desktop} {
    border-block-end: none;
    padding-block-end: 0;
    margin-block-end: 0;
  }

  svg {
    display: none;
    ${updatedMedia.desktop} {
      display: block;
    }
  }
  ${AddMonths} {
    svg {
      display: inline-block;
    }
  }
  ${updatedMedia.desktop} {
    display: flex;
  }
`
